import { history } from '../store';

let pathname;
const { gtag } = window;

export default function trackGoogleAnalytics(data) {

  // don't log navigating to same path
  if (data.pathname === pathname || typeof(gtag) !== 'function') {
    return;
  }

  gtag('config', 'UA-116935561-1', {
    'page_title': document.title,
    'page_location': window.location.href,
    'page_path': data.pathname,
    'history_action': history.action
  });

  pathname = data.pathname;

}



// WEBPACK FOOTER //
// ./src/services/analytics.js